import { CalendarClock } from "lucide-react";

export const daysUntil = (day) => Math.round((new Date(`${day}T00:00:00`) - new Date(new Date().toDateString())) / 86400000);

export const ResignCountdown = ({ day }) => {
  const n = daysUntil(day);
  const cls = n < 0 ? "border-slate-200 bg-slate-100 text-slate-600" : n <= 7 ? "border-red-200 bg-red-50 text-red-700" : "border-amber-200 bg-amber-50 text-amber-800";
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5" data-testid="resign-countdown">
      <span className="font-mono-nums" dir="ltr">{day}</span>
      <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-bold ${cls}`}>
        <CalendarClock className="h-3 w-3" /> {n < 0 ? `انتهت الخدمة منذ ${-n} يوم` : n === 0 ? "اليوم آخر يوم عمل" : `متبقٍ ${n} يوم`}
      </span>
    </span>
  );
};
